import Header from "../../header/Header";
import Footer from "../../footer/Footer";
import OwnerPersonalInfo from "../owner_personal_info/OwnerPersonalInfo";

function OwnerInfoLanding(){
    return(
        <div className="owner_info_landing">
            <Header />
            <OwnerPersonalInfo />
            <Footer />
        </div>
    )
}

export default OwnerInfoLanding